export const PRODUCT_ID = '830824';
export const ACCESS_TOKEN = 'aea4b8d1-b8c2-459a-ad3f-18166cdd7577';
